import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
// import SocketService from '@/utils/useWebSocket';
import DataVVue3 from '@kjgl77/datav-vue3';
import ArcoVue from '@arco-design/web-vue';
import '@/assets/css/global.scss';
import '@/assets/font/iconfont.css';
// SocketService.Instance.connect();
import '@arco-design/web-vue/dist/arco.css';

const app = createApp(App);
// app.config.globalProperties.$socket = SocketService.Instance;
app.use(createPinia());
app.use(router);
app.use(ArcoVue);
app.use(DataVVue3);
app.mount('#app');
